import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import Select, { components, createFilter } from 'react-select';
import { preventLinkScroll } from 'utils/commonUtils';
import { isMobile } from 'react-device-detect';

require('./Dropdown.scss');

@withRouter
export default class Dropdown extends Component {

  static propTypes = {
    router: PropTypes.object,
    options: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string,
      value: PropTypes.string,
      onSelect: PropTypes.func,
      text: PropTypes.string.isRequired
    })).isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    shouldNavigate: PropTypes.bool,
    showSelected: PropTypes.bool,
    noOptionsMessage: PropTypes.string
  }

  singleValue = ({ children, ...props }) => {
    return (
      <components.SingleValue {...props} className='dropdown-value'>
        {children}
      </components.SingleValue>
    )
  }

  handleChange = (selectedOption) => {
    const value = selectedOption.value;
    if (!value) {
      return;
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    }
    if (this.props.shouldNavigate
      && this.props.router.location !== value ) {
      this.props.router.push(preventLinkScroll(value));
    }
  }

  dropdownIndicator = (props) => {
    return components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <CaretIcon type={"line"} direction={"down"} />
      </components.DropdownIndicator>
    );
  };

  option = (props) => {
    let linkProps = {};
    if (this.props.shouldNavigate) {
      linkProps.to = preventLinkScroll(props.value)
    }
    const optionClass = props.isFocused 
      ? 'focused-dropdown-option'
      : 'not-focused-dropdown-option';
    return (
      <Link {...linkProps} className='dropdown-link'>
        <components.Option {...props} 
          className={`${optionClass} dropdown-value`}
        />
      </Link>
    );
  };

  noOptionsMessage = () => {
    if (this.props.noOptionsMessage) {
      return this.props.noOptionsMessage
    }
    const searchable = this.props.title.toLowerCase() || 'options'
    return `No ${searchable} found`
  }

  render() {
    const stringify = option => option.label;
    const filterOption = createFilter({ stringify });
    const props  = {
      components: {
        IndicatorSeparator: () => { return null },
        DropdownIndicator: this.dropdownIndicator,
        Option: this.option,
        SingleValue: this.singleValue
      },
      options: this.props.options.map((option) => {
        return { value: (option.href || option.value), label: option.text }
      }),
      menuShouldScrollIntoView: true,
      onChange: this.handleChange,
      isSearchable: !isMobile,
      noOptionsMessage: this.noOptionsMessage,
      className:  this.props.className + ' dropdown',
      filterOption: filterOption
    }
    props.placeholder = this.props.showSelected 
      ? props.options[0].label
      : this.props.title
    return <Select {...props}/>
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/Dropdown.js